import { IRedirectUrls, NavBarItems, RouteItems } from './types';
import {
  adminRoutes,
  commonRoutes,
  pointsManagerRoutes,
  polygonsManagerRoutes,
  requestsManagerRoutes,
  superAdminRoutes,
} from './routes';
import {
  // discountsNavItem,
  pointsNavItem,
  brandsNavItem,
  requestsNavItem,
  adminUsersNavItem,
  reviewsNavItem,
  productsNavItem,
  parsersNavItem,
  countriesNavItem,
  popularProductsNavItem,
  categoriesNavItem,
  scriptsNavItem,
  searchCoverageNavItem,
} from './navItems';

export const navBarItems: NavBarItems = {
  'super-admin': [
    pointsNavItem,
    productsNavItem,
    brandsNavItem,
    adminUsersNavItem,
    // discountsNavItem,
    requestsNavItem,
    reviewsNavItem,
    parsersNavItem,
    countriesNavItem,
    popularProductsNavItem,
    categoriesNavItem,
    scriptsNavItem,
    searchCoverageNavItem,
  ],
  admin: [
    pointsNavItem,
    productsNavItem,
    brandsNavItem,
    adminUsersNavItem,
    // discountsNavItem,
    requestsNavItem,
    reviewsNavItem,
    popularProductsNavItem,
    categoriesNavItem,
  ],
  'requests-manager': [requestsNavItem],
  'polygons-manager': [brandsNavItem],
  'points-manager': [pointsNavItem],
  'points-and-polygons-manager': [pointsNavItem, brandsNavItem],
};
export const redirectUrls: IRedirectUrls = {
  'super-admin': '/requests',
  admin: '/requests',
  'requests-manager': '/requests',
  'polygons-manager': '/brands',
  'points-manager': '/points',
  'points-and-polygons-manager': '/points',
};

export const routes: RouteItems = {
  all: [...[...superAdminRoutes].map((item) => ({ ...item, component: null })), ...commonRoutes],
  'super-admin': [...superAdminRoutes, ...commonRoutes],
  admin: [...adminRoutes, ...commonRoutes],
  'requests-manager': [...requestsManagerRoutes, ...commonRoutes],
  'polygons-manager': [...polygonsManagerRoutes, ...commonRoutes],
  'points-manager': [...pointsManagerRoutes, ...commonRoutes],
  'points-and-polygons-manager': [...pointsManagerRoutes, ...polygonsManagerRoutes, ...commonRoutes],
};
